// @flow
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Permissions } from "../../../helpers/constants";
import { organizerMenu } from "../../../helpers/menu/menu";
import useMenuAction from "../../../hooks/menu/useMenuAction";
import { NAVIGATION } from "../../../locales/components/namespaces";
import { useHasPermission } from "../../../modules/permission/hooks/useHasPermission";

type Props = {

};

const MenuWrapper = (props: Props) => {
	const { setMenuItems } = useMenuAction()
	const { t } = useTranslation(NAVIGATION)
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], {shouldView: true})
	// Το μενού του οργανωτή πρέπει να φτιαχτεί εξαρχής πριν διαλέξει κάποια έκθεση
	useEffect(() => {
		if (isOrganizer) {
			setMenuItems({items: [...organizerMenu(t)]})
			return () => {
				setMenuItems({ items: [] })
			}
		}
	}, [isOrganizer, setMenuItems, t])
	
	return (
		<>
			{props.children}
		</>
	);
};

export default MenuWrapper